/**
 * Etiqueta de identificación en reservas: DNI/CUIT (directo) o código externo.
 */
export const getReservationIdentityLabel = (
  origen?: string,
  withColon = false
): string => {
  let label = "DNI/CUIT";
  if (origen === "booking") label = "Código Booking";
  if (origen === "airbnb") label = "Código Airbnb";
  return withColon ? `${label}:` : label;
};
